/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import { useAlert } from "@cd2/components"
import { useTheme } from "@cd2/theme"
import React from "react"

function BasicAlert({ children, color }: { children: React.ReactNode; color?: string }) {
  const theme = useTheme()
  return (
    <div
      css={css`
        padding: 12px 24px;
        background-color: ${color};
        border-radius: ${theme.borderRadius}px;
        color: white;
      `}
    >
      <div
        css={css`
          max-width: 600px;
          margin: 0 auto;
        `}
      >
        <div>{children}</div>
      </div>
    </div>
  )
}

export function useSiteAlerts() {
  const { addAlert } = useAlert()

  function genericSuccess(msg: React.ReactNode) {
    addAlert({
      content: <BasicAlert>{msg}</BasicAlert>,
      status: "ok",
      position: "bottom",
      alertKey: Math.random().toString(),
    })
  }

  function genericInfo(msg: React.ReactNode) {
    addAlert({
      content: <BasicAlert color="rgba(0,0,0,0.8)">{msg}</BasicAlert>,
      status: "neutral",
      position: "bottom",
      alertKey: Math.random().toString(),
    })
  }

  function genericError(msg: React.ReactNode) {
    addAlert({
      content: <BasicAlert>{msg}</BasicAlert>,
      status: "error",
      position: "bottom",
      alertKey: Math.random().toString(),
    })
  }

  return {
    genericSuccess,
    genericInfo,
    genericError,
  }
}
